import _styled from "@emotion/styled-base";
import { c as _c } from "react-compiler-runtime";
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useFetchCart from '@nike/shop-apis/buy/carts/v2/fetch/use-query';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { numberFormat } from '@nike/i18n-core';
import { ButtonStyled } from '@nike/nike-design-system-components';
import trackMiniBagAction from './mini-bag-analytics';
import getWebShellClientLocale from "../../../state/redux-replacement/get-webshellclient-locale";
import { useItemAddedModalComponents } from "../base/ItemAddedModalContext";
import { Actions, SubtotalRow, SubtotalLabel, SubtotalPrice, SubtotalSkeletonRow, SubtotalLabelSkeleton, SubtotalPriceSkeleton, TwoUpButtonsStyled, ContinueShoppingLink } from "../base/styles";
import CheckoutButton from "../../checkout-button/CheckoutButton";
var EnhancedActionsWrapper = /*#__PURE__*/_styled('div', {
  target: "e1q78oqx0",
  label: "EnhancedActionsWrapper"
})("border-top:1px solid var(--podium-cds-color-border-tertiary);padding-top:var(--podium-cds-size-spacing-l);", Actions, "{gap:var(--podium-cds-size-spacing-m);}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var COHORT_MAP = {
  B: 'variantB',
  C: 'variantC'
};
var SubtotalSection = function SubtotalSection() {
  var $ = _c(17);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var _useFetchCart = useFetchCart(t0),
    cartData = _useFetchCart.data,
    isLoading = _useFetchCart.isLoading,
    isError = _useFetchCart.isError;
  var t1;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "summary.subtotal.label",
      primaryValue: "Subtotal",
      description: "Subtotal label"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var subtotalString = useI18nString(t1);
  var t2;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "header.item",
      primaryValue: "Item",
      description: "Item in My Cart"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  var itemString = useI18nString(t2);
  var t3;
  if ($[3] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = {
      stringKey: "header.items",
      primaryValue: "Items",
      description: "Items in My Cart"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  var itemsString = useI18nString(t3);
  if (isError) {
    return null;
  }
  if (isLoading || !(cartData !== null && cartData !== void 0 && cartData.currency)) {
    var _t;
    if ($[4] === Symbol["for"]("react.memo_cache_sentinel")) {
      _t = /*#__PURE__*/React.createElement(SubtotalSkeletonRow, {
        "data-automation": "mini-bag-subtotal-skeleton"
      }, /*#__PURE__*/React.createElement(SubtotalLabelSkeleton, null), /*#__PURE__*/React.createElement(SubtotalPriceSkeleton, null));
      $[4] = _t;
    } else {
      _t = $[4];
    }
    return _t;
  }
  var subtotal = cartData.subtotal,
    currency = cartData.currency,
    totalQuantity = cartData.totalQuantity;
  var t4;
  if ($[5] !== currency || $[6] !== subtotal) {
    var _getWebShellClientLoc;
    var _ref = (_getWebShellClientLoc = getWebShellClientLocale()) !== null && _getWebShellClientLoc !== void 0 ? _getWebShellClientLoc : {},
      localeForCurrency = _ref.hreflang;
    t4 = numberFormat(localeForCurrency, subtotal, {
      currency: currency
    });
    $[5] = currency;
    $[6] = subtotal;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  var formattedPrice = t4;
  var t5 = totalQuantity === 1 ? itemString : itemsString;
  var t6;
  if ($[8] !== t5) {
    t6 = t5.toLocaleLowerCase();
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  var itemLabel = t6;
  var t7 = "".concat(subtotalString, " (").concat(totalQuantity, " ").concat(itemLabel, ")");
  var t8;
  if ($[10] !== t7) {
    t8 = /*#__PURE__*/React.createElement(SubtotalLabel, null, t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  var t9;
  if ($[12] !== formattedPrice) {
    t9 = /*#__PURE__*/React.createElement(SubtotalPrice, null, formattedPrice);
    $[12] = formattedPrice;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  var t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = /*#__PURE__*/React.createElement(SubtotalRow, {
      "data-automation": "mini-bag-subtotal-row"
    }, t8, t9);
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
var EnhancedCartItemAddedModalActions = function EnhancedCartItemAddedModalActions(t0) {
  var $ = _c(26);
  var experience = t0.experience;
  var _useItemAddedModalCom = useItemAddedModalComponents(),
    handleCloseModal = _useItemAddedModalCom.handleCloseModal;
  var cohort = COHORT_MAP[experience];
  var ctaClickedRef = useRef(false);
  var t1;
  if ($[0] !== cohort) {
    t1 = function t1() {
      return function () {
        if (!ctaClickedRef.current) {
          trackMiniBagAction({
            actionName: "mini-bag:dismiss",
            cohort: cohort
          });
        }
      };
    };
    $[0] = cohort;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var t2;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  var t3;
  if ($[3] !== cohort) {
    t3 = function t3(actionName) {
      ctaClickedRef.current = true;
      trackMiniBagAction({
        actionName: actionName,
        cohort: cohort
      });
    };
    $[3] = cohort;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  var handleCtaClick = t3;
  var t4;
  if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
    t4 = {
      stringKey: "error.errorMessage.viewCart",
      primaryValue: "View Bag",
      description: "View Cart"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  var viewBagString = useI18nString(t4);
  var t5;
  if ($[6] === Symbol["for"]("react.memo_cache_sentinel")) {
    t5 = {
      stringKey: "checkout.cta.viewBagCheckout",
      primaryValue: "View Bag & Checkout",
      description: "View Bag & Checkout button in Mini-Bag"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  var viewBagAndCheckoutString = useI18nString(t5);
  var t6;
  if ($[7] === Symbol["for"]("react.memo_cache_sentinel")) {
    t6 = {
      stringKey: "checkout.checkoutButton",
      primaryValue: "Checkout",
      description: "Checkout button"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  var checkoutString = useI18nString(t6);
  var t7;
  if ($[8] === Symbol["for"]("react.memo_cache_sentinel")) {
    t7 = {
      stringKey: "cart.emptyMsg.cta",
      primaryValue: "Continue Shopping",
      description: "CTA for empty Cart"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  var continueShoppingString = useI18nString(t7);
  var t8;
  if ($[9] === Symbol["for"]("react.memo_cache_sentinel")) {
    var _window$NikeShop;
    t8 = (_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.get()) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.cartHref;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  var cartHref = t8;
  var t9;
  if ($[10] !== handleCloseModal || $[11] !== handleCtaClick) {
    t9 = function t9() {
      handleCtaClick("mini-bag:continue-shopping");
      handleCloseModal();
    };
    $[10] = handleCloseModal;
    $[11] = handleCtaClick;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  var handleContinueShoppingClick = t9;
  var t10;
  if ($[13] === Symbol["for"]("react.memo_cache_sentinel")) {
    t10 = /*#__PURE__*/React.createElement(SubtotalSection, null);
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  var t11;
  if ($[14] !== checkoutString || $[15] !== experience || $[16] !== handleCtaClick || $[17] !== viewBagAndCheckoutString || $[18] !== viewBagString) {
    t11 = experience === "B" ? /*#__PURE__*/React.createElement(TwoUpButtonsStyled, null, /*#__PURE__*/React.createElement(ButtonStyled, {
      appearance: "primary",
      size: "large",
      type: "button",
      Component: "a",
      href: cartHref,
      onClick: function onClick() {
        return handleCtaClick("mini-bag:view-bag");
      },
      "data-automation": "mini-bag-view-bag-button"
    }, viewBagString), /*#__PURE__*/React.createElement(CheckoutButton, {
      appearance: "secondary",
      onClick: function onClick() {
        return handleCtaClick("mini-bag:checkout");
      }
    }, checkoutString)) : /*#__PURE__*/React.createElement(ButtonStyled, {
      appearance: "primary",
      size: "large",
      type: "button",
      Component: "a",
      href: cartHref,
      onClick: function onClick() {
        return handleCtaClick("mini-bag:view-bag");
      },
      "data-automation": "mini-bag-view-bag-and-checkout-button"
    }, viewBagAndCheckoutString);
    $[14] = checkoutString;
    $[15] = experience;
    $[16] = handleCtaClick;
    $[17] = viewBagAndCheckoutString;
    $[18] = viewBagString;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  var t12;
  if ($[20] !== continueShoppingString || $[21] !== handleContinueShoppingClick) {
    t12 = /*#__PURE__*/React.createElement(ContinueShoppingLink, {
      type: "button",
      onClick: handleContinueShoppingClick,
      "data-automation": "mini-bag-continue-shopping"
    }, continueShoppingString);
    $[20] = continueShoppingString;
    $[21] = handleContinueShoppingClick;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  var t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = /*#__PURE__*/React.createElement(EnhancedActionsWrapper, null, /*#__PURE__*/React.createElement(Actions, null, t10, t11, t12));
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
EnhancedCartItemAddedModalActions.propTypes = {
  experience: PropTypes.oneOf(['B', 'C']).isRequired
};
export default EnhancedCartItemAddedModalActions;
function _temp(cart) {
  var _cart$totals, _cart$totals2;
  return {
    currency: cart === null || cart === void 0 ? void 0 : cart.currency,
    subtotal: (cart === null || cart === void 0 || (_cart$totals = cart.totals) === null || _cart$totals === void 0 ? void 0 : _cart$totals.subtotal) || 0,
    totalQuantity: (cart === null || cart === void 0 || (_cart$totals2 = cart.totals) === null || _cart$totals2 === void 0 ? void 0 : _cart$totals2.quantity) || 0
  };
}